import React from "react";

function ChildCareCallout() {
  return (
    <a
      className="child-care-callout"
      href="https://www.211childcare.org"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        className="child-care-callout-image"
        src="/images/child-care-callout.png"
        alt="Children playing with blocks"
      />
      <div className="child-care-callout-content">
        <span className="child-care-callout-title">
          Need Quality Connecticut Child Care?
        </span>
        <span className="child-care-callout-link">
          Visit 211childcare.org
          <svg
            className="child-care-callout-arrow"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M3.5 2H10V8.5M10 2L2 10"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>
    </a>
  );
}

export default ChildCareCallout;
